import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Instagram, Facebook, Linkedin } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_116c4487-fbc2-4d24-8bfa-fc864a8bb415/artifacts/pkspwc8q_logo%2025%20anos%20negativo.png" 
              alt="Paulare Empilhadeiras - 25 Anos" 
              className="h-24 w-auto object-contain"
            />
            <p className="text-gray-400 leading-relaxed">
              {companyInfo.experience} fornecendo soluções em movimentação de cargas para empresas de todos os portes.
            </p>
            <div className="flex gap-4">
              <a
                href={companyInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-500 transition-colors duration-300"
              >
                <Instagram size={20} />
              </a>
              <a
                href={companyInfo.social.facebook}
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-500 transition-colors duration-300"
              >
                <Facebook size={20} />
              </a>
              <a
                href={companyInfo.social.linkedin}
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-500 transition-colors duration-300"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-teal-400">Links Rápidos</h4>
            <ul className="space-y-3">
              {[
                { name: 'Home', path: '/' },
                { name: 'Produtos', path: '/produtos' },
                { name: 'Locação', path: '/locacao' },
                { name: 'Empresa', path: '/empresa' },
                { name: 'Diferenciais', path: '/diferenciais' },
                { name: 'Contato', path: '/contato' }
              ].map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-teal-400 transition-colors duration-300 flex items-center gap-2"
                  >
                    <span className="w-1.5 h-1.5 bg-teal-500 rounded-full"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-teal-400">Serviços</h4>
            <ul className="space-y-3">
              {['Venda de Empilhadeiras', 'Locação', 'Manutenção', 'Terceirização', 'Reforma', 'Pneus e Acessórios'].map((service) => (
                <li key={service}>
                  <span className="text-gray-400 flex items-center gap-2">
                    <span className="w-1.5 h-1.5 bg-teal-500 rounded-full"></span>
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-teal-400">Fale Conosco</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="flex items-start gap-3 text-gray-400 hover:text-teal-400 transition-colors duration-300"
                >
                  <Phone size={20} className="text-teal-500 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="font-medium text-white">{companyInfo.phone}</p>
                    <p className="text-sm">WhatsApp: {companyInfo.whatsappFormatted}</p>
                  </div>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-start gap-3 text-gray-400 hover:text-teal-400 transition-colors duration-300"
                >
                  <Mail size={20} className="text-teal-500 flex-shrink-0 mt-0.5" />
                  <span>{companyInfo.email}</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-gray-400">
                  <MapPin size={20} className="text-teal-500 flex-shrink-0 mt-0.5" />
                  <div>
                    <p>{companyInfo.address.street}</p>
                    <p>{companyInfo.address.neighborhood}</p>
                    <p>{companyInfo.address.city}/{companyInfo.address.state}</p>
                    <p>CEP: {companyInfo.address.cep}</p>
                  </div>
                </div>
              </li>
              <li>
                <div className="flex items-start gap-3 text-gray-400">
                  <Clock size={20} className="text-teal-500 flex-shrink-0 mt-0.5" />
                  <div>
                    <p>Segunda a Sexta</p>
                    <p>08:00 - 18:00</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} Paulare Empilhadeiras. Todos os direitos reservados.
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/privacidade" className="text-gray-400 hover:text-teal-400 transition-colors">Política de Privacidade</Link>
              <Link to="/termos" className="text-gray-400 hover:text-teal-400 transition-colors">Termos de Uso</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
